import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';

import { history, store } from '@webapp/account/src/resources/store';

import { SpeechRecognitionContextProvider } from '../lib/speech-recogn-context';

export const WithGlobalStore: FC<{
    element: ReactElement;
}> = ({ element }) => (
    <Provider store={store}>
        <SpeechRecognitionContextProvider>
            <Router history={history}>{element}</Router>
        </SpeechRecognitionContextProvider>
    </Provider>
);
